<template>
  <div>
  <v-card class="rounded-xl" color="cardOne" id="card-main" style="background-color: #fafafa !important">
    <v-container
      :class="$vuetify.breakpoint.name == 'xs' ? '' : 'pr-8 pl-8'"
      fluid
    >
      <v-row align="center" id="header">
        <v-col cols="4" sm="4" xs="4" md="2" lg="2" xl="2" style="text-align: center;">
          <v-img
            class="ml-2"
            :aspect-ratio="16 / 9"
            width="120"
            :src="require('../assets/logo-header2.png')"
            @click="$router.push('home');" 
            style="cursor: pointer;"
          ></v-img>
        </v-col>
        <v-col cols="8" sm="8" xs="8" md="3" lg="3" xl="3">
          <v-card
            class="rounded-xl"
            elevation="0"
            v-if="profile && token != ''"
          >
            <v-list-item two-line>
              <v-list-item-avatar>
                <v-menu bottom min-width="200px" rounded offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-large v-on="on">
                      <v-avatar size="60" title="Ver perfil">
                         <div class="v-image v-responsive theme--light"><div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div><div class="v-image__image v-image__image--cover" v-bind:style="{ 'background-image': 'url(' + user.imagen + ')','background-position': 'center center' }"></div><div class="v-responsive__content" style="width: 1229px;"></div></div>
                      </v-avatar>
                     
                    </v-btn>
                  </template>
                  <v-card>
                    <v-list-item-content class="justify-center">
                      <div class="mx-auto text-center">
                        <v-avatar size="60" title="Ver perfil" style="cursor: pointer;" @click="$router.push('profile/'+user.IDStB);">
                           <div class="v-image v-responsive theme--light"><div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div><div class="v-image__image v-image__image--cover" v-bind:style="{ 'background-image': 'url(' + user.imagen + ')','background-position': 'center center' }"></div><div class="v-responsive__content" style="width: 1229px;"></div></div>
                        </v-avatar>
                       
                        <h3 @click="$router.push('profile/'+user.IDStB);" style="cursor: pointer;">{{ user.Nombres }} {{ user.Apellidos }}</h3>
                        <p class="caption mt-1">
                          {{ user.email }}
                        </p>
                        <v-divider class="my-3"></v-divider>
                        <!-- <v-btn
                        depressed
                        rounded
                        text
                      >
                        Edit Account
                      </v-btn> -->
                        <!-- <v-divider class="my-3"></v-divider> -->
                        <div  v-if="user.borrado !== '1'">
                          <v-btn
                            @click="changePassword()"
                            depressed
                            rounded
                            text
                            class="black--text rounded-lg font-weight-regular"
                          
                          >
                            Cambiar contraseña
                          </v-btn>
                          <v-divider class="my-3"></v-divider>
                        </div>
                        <div  v-if="user.borrado !== '1'">
                          <v-btn
                            @click="$router.push('settings');"
                            depressed
                            rounded
                            text
                            class="black--text rounded-lg font-weight-regular"
                          
                          >
                            Ajustes
                          </v-btn>
                          <v-divider class="my-3"></v-divider>
                        </div>
                        <v-btn
                          @click="logout()"
                          depressed
                          rounded
                          text
                          class="black--text rounded-lg font-weight-regular"
                        >
                          Salir
                        </v-btn>
                      </div>
                    </v-list-item-content>
                  </v-card>
                </v-menu>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle
                  >Bienvenid@

                  
                  <div class="row ml-0" v-if="showRating">

                   <star-rating
                    v-model= "rating"
                    v-bind:increment="0.01"
                    v-bind:max-rating="5"
                    inactive-color="#f1f1f1"
                    active-color="#FFD700"
                    v-bind:star-size="20"
                    v-bind:read-only="true"
                    v-bind:show-rating="false"
                  >
                   
                  </star-rating>

                  <div class="ml-3">
                    <p class="mt-4"> {{rating.toFixed(1)}}</p>
                  </div>

                </div>
              
                </v-list-item-subtitle>  
                <v-list-item-title style="font-size:.8rem;"
                  ><strong>Reputación Institucional</strong></v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" xs="12" md="7" lg="7" xl="7">
          <div
            class="text-right text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text font-weight-light mr-5"
            v-if="user && user.IDStB && user.borrado !== '1' && user.tipoUsuario == 'alumno'"
          >
          
          
            <v-badge
              color="red"
              :content="notifications.general.total"
              overlap
              v-if="notifications.general.total > 0"
              >
              <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2"
                  fab
                  x-small
                  @click="LoadNotifications('general')"
                  title="Notificaciones"
                 
                >
                  <v-icon dark>
                     mdi-bell-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-list v-if="notifications.general.items.length > 0">
                <v-list-item
                v-for="(notification, index) in notifications.general.items" :key="index" 
                :style="{'background-color':notification.read? 'white' : '#f1f1f1'}"
                @click="openNotification(notification);"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{notification.title}}</v-list-item-title>
                    <v-list-item-subtitle :style="{'font-weight':notification.read? 'normal' : 'bold'}">{{notification.message}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                >
                </v-list-item>
              </v-list>
            </v-menu>
            </v-badge>
            <v-menu offset-y v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2"
                  fab
                  x-small
                  @click="LoadNotifications('general')"
                  title="Notificaciones"
                 
                >
                  <v-icon dark>
                     mdi-bell-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-list v-if="notifications.general.items.length > 0">
                <v-list-item
                v-for="(notification, index) in notifications.general.items" :key="index" 
                :style="{'background-color':notification.read? 'white' : '#f1f1f1'}"
                @click="openNotification(notification);"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{notification.title}}</v-list-item-title>
                    <v-list-item-subtitle :style="{'font-weight':notification.read? 'normal' : 'bold'}">{{notification.message}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                >
                </v-list-item>
              </v-list>
            </v-menu>
            
          
            <!--
            <v-badge
              color="red"
              :content="notifications.message.total"
              overlap
              v-if="notifications.message.total > 0"
              >
              <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2"
                  fab
                  x-small
                  @click="LoadNotifications('message')"
                  title="Notificaciones de chat"
                 
                >
                  <v-icon dark>
                     mdi-message-text-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-list v-if="notifications.message.items.length > 0">
                <v-list-item
                v-for="(notification, index) in notifications.message.items" :key="index" 
                @click="$router.push('chat/'+notification.origin_id);"
                :style="{'background-color':notification.read? 'white' : '#f1f1f1'}"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{notification.title}}</v-list-item-title>
                    <v-list-item-subtitle :style="{'font-weight':notification.read? 'normal' : 'bold'}">{{notification.message}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                >
                </v-list-item>
              </v-list>
            </v-menu>
            </v-badge>
            <v-menu offset-y v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2"
                  fab
                  x-small
                  title="Notificaciones de chat"
                  @click="LoadNotifications('message')"
                 
                >
                  <v-icon dark>
                     mdi-message-text-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-list v-if="notifications.message.items.length > 0">
                <v-list-item
                v-for="(notification, index) in notifications.message.items" :key="index" 
                @click="goChat(notification.origin_id)"
                :style="{'background-color':notification.read? 'white' : '#f1f1f1'}"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{notification.title}}</v-list-item-title>
                    <v-list-item-subtitle :style="{'font-weight':notification.read? 'normal' : 'bold'}">{{notification.message}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                >
                </v-list-item>
              </v-list>
            </v-menu>
            <v-badge
                color="red"
                :content="notifications.post.total"
                v-if="notifications.post.total > 0"
                overlap
              >
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2"
                    fab
                    x-small
                    @click="LoadNotifications('post')"
                   title="Notificaciones de posteos"
                  >
                    <v-icon dark>
                      mdi-newspaper
                    </v-icon>
                  </v-btn>
                </template>
                <v-list v-if="notifications.post.items.length > 0">
                  <v-list-item
                  v-for="(notification, index) in notifications.post.items" :key="index" 
                  
                  @click="goPublication(notification.origin_id)"
                  :style="{'background-color':notification.read? 'white' : '#f1f1f1'}"

                  >
                    <v-list-item-content>
                      <v-list-item-title>{{notification.title}}</v-list-item-title>
                      <v-list-item-subtitle :style="{'font-weight':notification.read? 'normal' : 'bold'}">{{notification.message}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                  >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-badge>
            <v-menu offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2"
                    fab
                    x-small
                    @click="LoadNotifications('post')"
                    title="Notificaciones de posteos"
                   
                  >
                    <v-icon dark>
                      mdi-newspaper
                    </v-icon>
                  </v-btn>
                </template>
                <v-list v-if="notifications.post.items.length > 0">
                  <v-list-item
                  v-for="(notification, index) in notifications.post.items" :key="index" 
                  
                  @click="goPublication(notification.origin_id)"
                  :style="{'background-color':notification.read? 'white' : '#f1f1f1'}"

                  >
                    <v-list-item-content>
                      <v-list-item-title>{{notification.title}}</v-list-item-title>
                      <v-list-item-subtitle :style="{'font-weight':notification.read? 'normal' : 'bold'}">{{notification.message}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                  >
                  </v-list-item>
                </v-list>
              </v-menu>
            -->
              <v-btn
                color="orange"
                dark
                class="mx-2"
                fab
                x-small
                @click="goChats()"
                v-if="$route.name=='Publicacion' || $route.name=='Profile'"
                title="Ver chat"
               
              >
                <v-icon dark>
                  mdi-message-processing
                </v-icon>
              </v-btn>
              <v-btn
                color="red"
                dark
                class="mx-2"
                fab
                x-small
                @click="goPublications()"
                v-else
                title="Ver posteos"
               
              >
                <v-icon dark>
                  mdi-newspaper
                </v-icon>
              </v-btn>
         
                    
                  </div>
                  <p
                    class="text-right"
                  >
                  <!--
                  <a href="https://sistemaiea.com/public.login.php?var=entry&redirect=0" style="text-decoration: none;">Volver a la versión anterior</a>
                  --> 
                  </p>

                </v-col>
              </v-row>
              <v-row align="center">

                <slot></slot>
              </v-row>
            </v-container>
  </v-card>
  <p style="text-align: center;">
    <small style="color: #ccc;">V.3.0.3</small>
  </p>
</div>
</template>

<script>
import StarRating from 'vue-star-rating'
import SocketConnection from "itoeste-socket"
import { DEBUG, API_SOCKET } from "../../env";
export default {
  props: {
    profile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rating: 1.0,
      showRating: false,
      notifications:{
        'general':{total:0, items:[]},
        'message':{total:0, items:[]},
        'post':{total:0, items:[]},
      },
      ws:null
    };
  },
  components: {
    StarRating,
  },
  mounted() {
    if(this.user && this.user.IDStB){
      //Se obtienen los datos del alumno

      if (this.user.tipoUsuario == "alumno") {
        this.$API
        .get({
          url: "alumno/getAlumno",
          data: {},
        })
        .then((res) => {
          if(res){
            this.rating = res.puntaje
            this.showRating = true;
          }
        });

      //Se obtienen las notificaciones
      this.$API
        .get({
          url: "notifications-total",
          data: {},
        })
        .then((res) => {
          if(res){
            let m = res.filter(d => {return (d.type == 'message')});
            if(m.length > 0){
              //this.notifications.message.total = m[0].total;  
              this.notifications.general.total = m[0].total;  
            }
            let p = res.filter(d => {return (d.type == 'post')});
            if(p.length > 0){
              //this.notifications.post.total = p[0].total;  
              this.notifications.general.total = p[0].total;  

            }

            let g = res.filter(d => {return (d.type == 'general')});
            if(g.length > 0){
              this.notifications.general.total = g[0].total;  
            }
          }
        });
        
      }
      
      this.ws = SocketConnection({
        debug:DEBUG,
        token:API_SOCKET,
        user:this.$store.getters.user.IDStB
      },()=>{
        
      });
      this.ws.subscribeChannel('notification-' + this.user.IDStB, (result) => {
        console.log('llego por curl notificc')
        console.log(result);
        this.notifications.general.total++;
        /*
        switch (result.type){
            case "post":
              this.notifications.post.total++;
            break;
            case "message":
              this.notifications.message.total++;
            break;
            case "general":
              this.notifications.general.total++;
            break;
          }
          */
      });
      this.ws.subscribeChannel('chat-' + this.user.IDStB, (result) => {
        console.log('llego por curl notifi')
        console.log(result);
        switch (result.action){
            case "chat-new", "message-new":
              this.addNotificationMessage(result)
            break;
          }
      });
    }
  },
  computed: {

    token() {
      return this.$store.getters.token;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "alumno/logout",
          data: {},
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    async changePassword() {
      this.$router.push({
            name: 'ChangePassword'
          });  
    },
    async LoadNotifications(tipo){
      console.log(tipo)
      //this.notifications[tipo].total = 0
      this.$API
      .get({
        //url: "notifications?per_page=5&type=" + tipo 
        url: "notifications?per_page=5"
      }).then((res) => {
        this.notifications['general'].items = res.data;
        if(this.notifications['general'].total > 0){
          this.$API
          .post({
            url: "notifications-reset",
            data:{}
          }, false)
        }
      });
    },
    openPublication(id){
      this.$router.replace({
            name: 'Publicaciones',
            params:{id:id}
          });  
    },
    addNotificationMessage(result){
      console.log(result)
      let ch = JSON.parse(result.message);
      if(ch.alumno_id !== this.user.IDStB){
        //this.notifications.message.total++;  
        this.notifications.general.total++;  
      }
    },
    goPublications(){
      this.$router.push({
        name: 'Publicacion'
      });  
    },
    goChats(){
      this.$router.push({
        name: 'Chat'
      });  
    },
    goChat(id){
      this.$router.push({
        name: 'Chat',
        params:{id:id},
        query: {
          t: new Date().getTime(),
        }
      });
    },
    goPublication(id){
      this.$router.push({
        name: 'Publicacion',
        params:{id:id},
        query: {
          t: new Date().getTime(),
        }
      });
    },
    openNotification(notification){
      if(notification.type == 'message'){
        this.goChat(notification.origin_id);
      }else if(notification.type == 'post'){
        this.goPublication(notification.origin_id);
      }

    }
  }
};
</script>
